
import React from "react";
import {
  Create,

  Show,
  SimpleShowLayout,
  TextField,
  TopToolbar,
  ShowButton, useResourceContext
} from "react-admin";

import alasql from "alasql";

import {formMapCreate} from './ui/formMap';
import WorkFlowButton from './WorkFlowButton';


const EditActions = ({ basePath, data, resource, columns }) => {

  //if (loading) return "loading ...";
  var Hooks = [];
  var workflow = 'none';

  //console.log(resource);

  let actions = [];

  if (typeof data !== 'undefined') {
    const role = localStorage.getItem('role');

    //console.log(resource);

    //get workflow key
    let stc = alasql(`select distinct StateColumn as col  from workflows where Module ='${resource}' and   role_${role}='control' `).map(({ col }) => col);

    if (typeof stc !== 'undefined' && typeof stc[0] !== 'undefined') {
      //if we have key check type and get list of actions json for current step
      //console.log(isNaN(`${data[stc[0]]}`));

      if (isNaN(`${data[stc[0]]}`)) {

        actions = alasql(`select * from workflows where Module ='${resource}' and   role_${role}='control' and  StateColumn='${stc[0]}' and StateValue='${data[stc[0]]}'`).map(col => col);
      } else {
        //actions = alasql(`select * from workflows where Module ='${resource}' and   role_${role}='control' and  StateColumn='${stc[0]}' and StateValue=${record[stc[0]]}`).map(col => col);
        actions = alasql(`select * from workflows where Module ='${resource}' and   role_${role}='control' and  StateColumn='${stc[0]}' and StateValue='${data[stc[0]]}'`).map(col => col);

      }
      //get actions objects

      if (typeof actions[0] !== 'undefined' && typeof actions[0].Actions !== 'undefined') {
        let actData = actions[0].Actions;
        if (actData != '[]') {

          Hooks = alasql(`select * from workflows where Module ='${resource}' and   role_${role}='control' and  WorkFlowName= ANY (ARRAY${actData})`).map(col => col);
          workflow = actions[0].WorkFlowName;
        }
      }
    }


  }
  return (
    <TopToolbar>
      <ShowButton basePath={basePath} record={data} />

      {Hooks.map((f, index) => <WorkFlowButton actData={f} key={index} basePath={basePath} record={data} />)}

    </TopToolbar>
  )
};


const mapStateToProps = state => ({
  // recordLiveValues: getFormValues('record-form')(state)
  recordLiveValues: state
});

const ResourceCreate = props => {

  let state = {
    loading: true,
    resourcesFields: [],
    resourcesTabs: [],
    resourcePermistions: [],
    tabs: [],
    canDelete: false,

  };

  const {
    loading,

    canDelete
  } = state;
  //console.log('resourcePermistions', resourcePermistions)
  const { recordLiveValues, resource, id, rdata } = props;



  const role = localStorage.getItem("role");


  let resourcePermistions = alasql(
    `select form_mode,inline_update,init_values from resource_permistions  where resource_name ='${resource}' `
  );


  var inlineQuery = '';
  var form_mode = 'UiTabbedForm';
  ;
  let initValues = {};
  let redirect = 'edit';


  if (resourcePermistions.length > 0) {
    const { init_values } = resourcePermistions[0];

  

    if (init_values) {

      try {
        const parsedInitValues = JSON.parse(init_values);
        if (parsedInitValues.columns) {
          initValues = parsedInitValues.columns;
        }
        if (parsedInitValues.redirect) {
          redirect = parsedInitValues.redirect;
        }
      } catch (error) {
        console.error("Error parsing init_values:", error);
      }
    }
  }



  if (resourcePermistions && resourcePermistions[0]) {
    if (resourcePermistions[0].inline_update) {
      resourcePermistions[0].form_mode = 'UiInlineForm';

    }

    form_mode = resourcePermistions[0].form_mode;

    if (resourcePermistions[0].inline_update) {

      inlineQuery = 'and   is_inline=true';

    }

  }


  let tabs = alasql(
    `select distinct write_group as tab  from resources where resource_name ='${resource}'  ${inlineQuery}  and   is_create_field =true and  (role_${role}='write' or role_${role}='read' )`
  ).map(({ tab }) => tab);



  let resourcesFields = alasql(
    `SELECT DISTINCT write_group AS tab FROM resources WHERE  is_create_field = true and resource_name ='${resource}' ${inlineQuery} `
  ).map(({ tab }) =>
    alasql(`SELECT watched_column,grid_class, grid_xs, grid_sm, is_require_separator, is_require_label, label_text, source_name,
      CASE
        WHEN role_${role} = 'read' THEN field_widget_type
        ELSE edit_input_widget_type
      END AS input_widget_type,
      field_meta, annotation, css_class, edit_css_class, full_width, is_required,
      { 
        "workflow_conditional": workflow_conditional, 
        "workflow_column": workflow_column, 
        "workflow_conditional_show": workflow_conditional_show, 
        "workflow_conditional_readonly": workflow_conditional_hide,
        "workflow_conditional_readonly_type":field_widget_type
      } AS workflow_info
      FROM resources WHERE write_group = "${tab}" AND resource_name = '${resource}'
      AND ((role_${role} = 'write' AND is_create_field = true) OR ( is_create_field = true and  role_${role} = 'read')) ${inlineQuery}`)
  );


  const resourcesTabs = alasql(`
  SELECT DISTINCT r.write_group AS tab, 
                  COALESCE(ct.width_class, 12) AS width_class, 
                  COALESCE(ct.new_line_after, false) AS new_line_after
  FROM resources AS r
  LEFT JOIN custom_tabs AS ct
  ON r.resource_name = ct.resource_name AND r.write_group = ct.tab_id
  WHERE   is_create_field = true and r.resource_name = '${resource}' ${inlineQuery}
`).map(({ tab, width_class, new_line_after }) => ({ tab, width_class, new_line_after }));



  // filter resourcesFields
  resourcesFields = resourcesFields.filter(d => d.length > 0);

  let headerFields = alasql(`select  watched_column,grid_class,grid_xs,grid_sm,is_require_separator,is_require_label,label_text,source_name,edit_input_widget_type as input_widget_type, field_meta , annotation , css_class, edit_css_class, full_width, is_required from resources where  resource_name ='${resource}'  and is_create_field =true
  AND ( role_${role}='read' ) and annotation ="header"`);







  return (
    <>
      {resourcePermistions && resourcePermistions[0] && !resourcePermistions[0].inline_update && headerFields.length > 0 && (
        <Show {...props} actions={<></>}>
          <SimpleShowLayout>
            {headerFields.map((f, index) => (
              <TextField
                source={f.source_name}
                className="show-field-compressed"
                key={index}
              />
            ))}
          </SimpleShowLayout>
          <hr />

        </Show>

      )}

      <Create redirect={redirect}
        actions={form_mode != 'UiInlineForm' && <EditActions resource={resource} data={rdata} />}
        {...props}
        initialValues={initValues}

        
        >

        {formMapCreate(initValues,form_mode, resourcesFields, resourcesTabs, canDelete, tabs, id)}






      </Create>
    </>
  );
}




const UiResourceCreate = props => {
  //console.log(props);
  const resource = useResourceContext();



  return <ResourceCreate resource={resource}  {...props} />;
};

export default UiResourceCreate;



